import React, {Component} from 'react';

class Blogs extends Component {
    render() {
        return(
            
            <div >
                <img src="https://blog.focusinfotech.com/wp-content/uploads/2017/08/blog-banner.jpg" alt="Blogs" width="100%" height="100%" />
            </div>
            
        )
    }
}
export default Blogs;
